<p-table [scrollable]="true" scrollHeight="200px" [value]="inputRecords" dataKey="id" editMode="row">
  <ng-template pTemplate="header">
    <tr>
      <th>Date</th>
      <th>Result</th>
      <th>User</th>
      <th>Action</th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-gasTestRecord let-editing="editing" let-ri="rowIndex">
    <tr [pEditableRow]="gasTestRecord">
      <td>
        <p-cellEditor>
          <ng-template pTemplate="input">
            <p-calendar hourFormat="12" [disabled]="true" [showIcon]="true" dateFormat="dd/mm/yy" [showTime]="true"
              [(ngModel)]="gasTestRecord.date" readonlyInput="true" required #timeOfUse="ngModel" appendTo="body"
              hideOnDateTimeSelect="true" monthNavigator="true" yearNavigator="true" yearRange="1950:2100">
            </p-calendar>
          </ng-template>
          <ng-template pTemplate="output">
            {{gasTestRecord.date | date: 'dd/MM/yyyy hh:mm a'}}
          </ng-template>
        </p-cellEditor>
      </td>
      <td>
        <p-cellEditor>
          <ng-template pTemplate="input">
            <textarea cols="8" [(ngModel)]="gasTestRecord.result" required></textarea>
          </ng-template>
          <ng-template pTemplate="output">
            {{gasTestRecord.result}}
          </ng-template>
        </p-cellEditor>
      </td>
      <td>
        <p-cellEditor>
          <ng-template pTemplate="input">
            <input pInputText type="text" disabled [(ngModel)]="gasTestRecord.username" required>
          </ng-template>
          <ng-template pTemplate="output">
            {{gasTestRecord.username}}
          </ng-template>
        </p-cellEditor>
      </td>
      <td style="text-align:center">
        <button *ngIf="!editing && (lastValue < gasTestRecord.id || (lastValue >= gasTestRecord.id && ( Permissions.PTW_Admin || Permissions.PTW_Admin_Unit)))" pButton pRipple type="button" pInitEditableRow icon="pi pi-pencil"
          (click)="onRowEditInit(gasTestRecord)" class="p-button-rounded p-button-text"></button>
        <button *ngIf="!editing && (lastValue < gasTestRecord.id || (lastValue >= gasTestRecord.id && ( Permissions.PTW_Admin || Permissions.PTW_Admin_Unit)))" pButton type="button" icon="pi pi-trash" (click)="onRowDeleteInit(ri)"
          class="p-button-rounded p-button-text"></button>
        <button *ngIf="editing && (lastValue < gasTestRecord.id || (lastValue >= gasTestRecord.id && ( Permissions.PTW_Admin || Permissions.PTW_Admin_Unit)))" pButton pRipple type="button" pSaveEditableRow icon="pi pi-check"
          (click)="onRowEditSave(gasTestRecord,ri)"
          class="p-button-rounded p-button-text p-button-success p-mr-2"></button>
      </td>
    </tr>
  </ng-template>
</p-table>
<div *ngIf="addRecords">
  <input type="button" class="btn btn-link" (click)="addRecord()" value="Add Record">
</div>

<p-dialog [(visible)]="productDialog" (onHide)="closePopUp()" header="Add Record" [modal]="true" >
  <div class="p-field">
    <label for="name">Date</label>
    <div class="p-calendar">
      <p-calendar hourFormat="12" [showIcon]="true" dateFormat="dd/mm/yy" [showTime]="true"
        [(ngModel)]="inputRecord.date" readonlyInput="true" required #timeOfUse="ngModel" appendTo="body"
        hideOnDateTimeSelect="true" monthNavigator="true" yearNavigator="true" yearRange="1950:2100">
      </p-calendar>
    </div>
  </div>

  <div class="p-field">
    <label for="name">Result</label><div class="clearfix"></div>
    <textarea pInputText rows="6" [(ngModel)]="inputRecord.result" required></textarea>
  </div>

  <ng-template pTemplate="footer">
    <button pButton pRipple label="Save" icon="pi pi-check" class="p-button-text button-submit" (click)="saveRecord()"></button>
    <button pButton pRipple label="Cancel" icon="pi pi-times" class="p-button-text button-cancel" (click)="productDialog = false"></button>
  </ng-template>
</p-dialog>
